import { Component, OnDestroy, OnInit } from '@angular/core'
import { fromEvent, Subscription, timer } from 'rxjs'

@Component({
    selector: 'fm-home-welcome-message',
    template: `<span>{{ greeting }}</span>`,
})
export class HomeWelcomeMessageComponent implements OnInit, OnDestroy {
    greeting: string = ''
    private timerSub?: Subscription
    private visibilitySub?: Subscription

    ngOnInit(): void {
        this.updateGreetingAndScheduleNext()

        // Listen for tab becoming visible again
        this.visibilitySub = fromEvent(document, 'visibilitychange').subscribe(() => {
            if (document.visibilityState === 'visible') {
                this.updateGreetingAndScheduleNext()
            }
        })
    }

    private updateGreetingAndScheduleNext(): void {
        const now = new Date()
        const currentHour = now.getHours()

        if (currentHour < 12) {
            this.greeting = 'Good Morning'
        } else if (currentHour < 17) {
            this.greeting = 'Good Afternoon'
        } else {
            this.greeting = 'Good Evening'
        }

        const nextChange = this.getNextTransitionTime(now)
        const delay = nextChange.getTime() - now.getTime()

        this.timerSub?.unsubscribe() // Clear previous timer if any

        this.timerSub = timer(delay).subscribe(() => {
            this.updateGreetingAndScheduleNext() // Recursively update
        })
    }

    private getNextTransitionTime(now: Date): Date {
        const next = new Date(now)

        if (now.getHours() < 12) {
            // Next change at 12:00 PM
            next.setHours(12, 0, 0, 0)
        } else if (now.getHours() < 17) {
            // Next change at 5:00 PM
            next.setHours(17, 0, 0, 0)
        } else {
            // Next change at 12:00 AM (midnight)
            next.setDate(next.getDate() + 1)
            next.setHours(0, 0, 0, 0)
        }

        return next
    }

    ngOnDestroy(): void {
        this.timerSub?.unsubscribe()
        this.visibilitySub?.unsubscribe()
    }
}
